import { apiSlice } from '@/api/api.slice.tsx';

/**
 * Mirrors the backend `StripePaymentMethodPartnerDto` returned by
 * `GetWireTransferSetupController`. Nullable PHP fields serialize as `null`.
 */
export interface GetWireTransferSetupResponse {
  id: string;
  stripePaymentMethodPartnerId: number | null;
  stripeId: string | null;
  creationDate: string;
  type: string;
  cardBrand: string | null;
  cardCountryCode: string | null;
  cardExpMonth: number;
  cardExpYear: number;
  cardLast4: string | null;
  sepaDebitBankCode: string | null;
  sepaDebitBranchCode: string | null;
  sepaDebitCountryCode: string | null;
  sepaDebitFingerprint: string | null;
  sepaDebitLast4: string | null;
  virtualIban: string | null;
  virtualBic: string | null;
  virtualIbanCountryCode: string | null;
  virtualUsAccountNumber: string | null;
  virtualUsRoutingNumber: string | null;
  isDefault: boolean;
}

const curr = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWireTransferSetup: builder.query<GetWireTransferSetupResponse, void>({
      providesTags: ['FundingPaymentMethod'],
      query: () => ({
        url: '/get-wire-transfer-setup',
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useLazyGetWireTransferSetupQuery,
  useGetWireTransferSetupQuery,
} = curr;
